import { FirestoreOrganisationLanguage } from "reedy-data/api";

export function mapProductLanguageToThema(productLanguage: string): string {
  const normalized = productLanguage.toLowerCase().trim();

  switch (normalized) {
    case "eng":
      return "en";
    case "ger":
      return "de";
    case "The language of the book title":
      return "en";
    default:
      return "en";
  }
}

export function mapOrganisationLanguageToThema(
  language: FirestoreOrganisationLanguage,
): "en" | "de" {
  switch (language) {
    case FirestoreOrganisationLanguage.DE_DE:
      return "de";
    case FirestoreOrganisationLanguage.EN_GB:
      return "en";
    case FirestoreOrganisationLanguage.EN_US:
      return "en";
    default:
      return "en";
  }
}
